/*global define*/
define('core/services/LoggingService',['angular'], function(angular) {
    'use strict';
    return angular.module('dnaApp').service('LoggingService', ['$http', function($http) {

        var KEY_EVENT_NAME = "eventName";
        var KEY_HOST = 'hostName';
        var KEY_PROPERTIES = "eventProperties";
        var KEY_MESSAGE = "Message";
        var KEY_TIMESTAMP = 'TimeStamp';
        var HOST = dna.app.ancestryBaseUrl;
        var propertiesData = {};

        var AVAILABLE_LEVELS = ["DEBUG", "INFO", "WARN", "ERROR"];

        function dataSent(){
            return propertiesData;
        }

        function sendToFel(properties) {
            var url = dna.app.felServiceUrl + '/events';

            propertiesData = properties;

            $http({
                withCredentials: true,
                method: 'POST',
                url: url,
                headers: {dnaVersion: undefined},
                data: properties
            });
        }

        function logToServer(level, message, objects) {
            level = (level || "").toUpperCase();
            if(AVAILABLE_LEVELS.indexOf(level) == -1) {
                level = "INFO";
            }
            sendToFel(propertiesFillUp(level, message, objects));
        }

        function propertiesFillUp(level, message, objects) {
            var properties = {};
            properties[KEY_EVENT_NAME] = level;
            properties[KEY_HOST] = HOST;
            properties[KEY_PROPERTIES] = objects;
            properties[KEY_MESSAGE] = message;
            properties[KEY_TIMESTAMP] = new Date().toISOString();
            return JSON.stringify(properties);
        }

        return {

            dataSent: dataSent,

            eventLog: logToServer

        };
    }]);
});
